export default __webpack_public_path__ + "static/media/Barlow-Medium.c2228f2e.otf";